export default __webpack_public_path__ + "static/media/lodgify_step4.9bb2c3ec.jpg";